var _classCallCheck = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/codebuild/output/src1039780453/src/web/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Declaration = require('../declaration');

var _require = require('./grid-utils'),
    parseTemplate = _require.parseTemplate,
    warnMissedAreas = _require.warnMissedAreas,
    getGridGap = _require.getGridGap,
    warnGridGap = _require.warnGridGap,
    inheritGridGap = _require.inheritGridGap;

var GridTemplate = /*#__PURE__*/function (_Declaration) {
  "use strict";

  _inherits(GridTemplate, _Declaration);

  var _super = _createSuper(GridTemplate);

  function GridTemplate() {
    _classCallCheck(this, GridTemplate);

    return _super.apply(this, arguments);
  }

  _createClass(GridTemplate, [{
    key: "insert",
    value:
    /**
     * Translate grid-template to separate -ms- prefixed properties
     */
    function insert(decl, prefix, prefixes, result) {
      if (prefix !== '-ms-') return _get(_getPrototypeOf(GridTemplate.prototype), "insert", this).call(this, decl, prefix, prefixes);

      if (decl.parent.some(function (i) {
        return i.prop === '-ms-grid-rows';
      })) {
        return undefined;
      }

      var gap = getGridGap(decl);
      /**
       * we must insert inherited gap values in some cases:
       * if we are inside media query && if we have no grid-gap value
       */

      var inheritedGap = inheritGridGap(decl, gap);

      var _parseTemplate = parseTemplate({
        decl: decl,
        gap: inheritedGap || gap
      }),
          rows = _parseTemplate.rows,
          columns = _parseTemplate.columns,
          areas = _parseTemplate.areas;

      var hasAreas = Object.keys(areas).length > 0;
      var hasRows = Boolean(rows);
      var hasColumns = Boolean(columns);
      warnGridGap({
        gap: gap,
        hasColumns: hasColumns,
        decl: decl,
        result: result
      });
      warnMissedAreas(areas, decl, result);

      if (hasRows && hasColumns || hasAreas) {
        decl.cloneBefore({
          prop: '-ms-grid-rows',
          value: rows,
          raws: {}
        });
      }

      if (hasColumns) {
        decl.cloneBefore({
          prop: '-ms-grid-columns',
          value: columns,
          raws: {}
        });
      }

      return decl;
    }
  }]);

  return GridTemplate;
}(Declaration);

GridTemplate.names = ['grid-template'];
module.exports = GridTemplate;